module.exports = __webpack_public_path__ + "img/pre-save-open-tip.af8cef9f.png";